import React from 'react';
import PropTypes from 'prop-types';

import './index.css';

const Checkbox = ({
                      disabled, checked, handleChange, text, wrapperStyle, size, marginBottom
                  }) => {
    let wrapperClass = 'custom-checkbox';
    if (checked) {
        wrapperClass += ' checked';
    }

    if (disabled) {
        wrapperClass += ' disabled';
    }

    return (
        <React.Fragment>
            <input type="checkbox" checked={checked} onChange={(event) => {
                handleChange(event.target.checked);
            }}/>
        </React.Fragment>
    )
};

Checkbox.propTypes = {
    disabled: PropTypes.bool,
    checked: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    text: PropTypes.string,
    wrapperStyle: PropTypes.object,
    size: PropTypes.string,
};

Checkbox.defaultProps = {
    disabled: false,
    wrapperStyle: {},
    size: '15px',
    text: ''
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/checkbox/index.jsx